import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

export const ON_HOLD_STEPS = {
  INTRO: 'intro',
  MAKE_COUNTER_OFFER_REASONS: 'makeCounterOffer',
  MAKE_COUNTER_OFFER_DETAILS: 'makeCounterOfferDetails',
  CUSTOMER_ACTION: 'customerActionNeeded',
  TRANSPORT_ISSUE: 'transportIssue',
  REFUSE_ITEM: 'refuseItem',
} as const

export const COUNTEROFFER_ROLES = {
  ADMIN: 'ADMIN',
  MERCHANT: 'MERCHANT',
}

// These 4 values are used only in tests as runtime values are stores in useBuybackConfig.ts
export const COUNTRIES_WITH_GDPR = [
  MarketCountryCode.FR,
  MarketCountryCode.ES,
  MarketCountryCode.DE,
  MarketCountryCode.GB,
]

export const COUNTRIES_WITHOUT_GDPR = [MarketCountryCode.US]

export const COUNTRIES_WITH_SMS_CONSENT = [MarketCountryCode.US]

export const COUNTRIES_WITHOUT_SMS_CONSENT = [
  MarketCountryCode.FR,
  MarketCountryCode.ES,
  MarketCountryCode.DE,
  MarketCountryCode.GB,
]

export const REFURBISHER_ACTIONS = {
  VALIDATE: 'refurbisherValidateOrder',
  VALIDATE_ACTION: 'refurbisherValidateOrderAction',
  PUT_ON_HOLD: 'refurbisherPutOnHoldOrder',
  COUNTER_OFFER: 'refurbisherNewCounterOffer',
}

export const SWAP_INFO_MESSAGE = {
  SWAP_POPULAR: '[BUYBACK][API][SWAP] Error in swap popular searches',
  SWAP_SEARCH: '[BUYBACK][API][SWAP] Error in swap search',
  DELETE_SWAP: '[BUYBACK][API][SWAP] Error deleting swap',
}

export const MODAL_NAMES = {
  GRADING_WITH_IA: 'GRADING_WITH_IA',
}
